export default {
    error: {
        'title': 'Ошибка',
        'unknown': 'Ошибка соединения с сервером',
        '1': 'Внутренняя ошибка базы данных',
        '2': 'Получена неизвестная команда от RESTful сервиса',
        '3': 'Неверный формат данных',
        '4': 'Некорректное действие',
        '5': 'Нельзя осуществить вход в систему (неверный логин, пароль, отсутствует такой пользователь)',
        '6': 'Сессия не существует или истекла',
        '7': 'Доступ запрещен (нет прав, нет подходящей лицензии)',
        '8': 'Некорректный сервер назначения',
        '9': 'Отсутствует или не найден сервер обновления',
        '10': 'Отсутствует ключ сессии',
        '11': 'Отстутствует регистрация на support сервере',
        '12': 'Нет регистрации на support сервере - логин занят',
        '13': 'Переданные данные были потеряны',
        '14': 'Пользователь уже зарегистрирован в HR сети',
        '15': 'Слишком большое количество пользователей в HR сети',
        '16': 'Сотрудник не зарегистрирован в HR сети',
        '17': 'Неверный ключ аутентификации',
        '18': 'Данные не загружены',
        '19': 'Неизвестный или просроченный ключ аутентификации в ссылке',
        '20': 'Данный проект тестирования завершен',
        '21': 'Логин уже зарегистрирован',
        '22': 'Неверный пользовательский логин',
        '23': 'Нет проекта по умолчанию',
        '24': 'Текущий скрипт или тест не задан',
        '25': 'Некорректный формат сторонней XML (SHL)',
        '26': 'Неизместный метод (SHL)',
        '27': 'В XML нет поля с результатом (SHL)',
        '28': 'В XML пустое поле с результатом (SHL)',
        '29': 'В XML поле с результатом содержит некорректное значение (SHL)',
        '30': 'Нет кода клиента (SHL)',
        '31': 'Некорректный код Experium (SHL)',
        '32': 'Нет кода компании (SHL)',
        '33': 'Нет кода Experium (SHL)',
        '34': 'Нет данных о результате (SHL)',
        '35': 'Не найдено соответствующее событие (SHL)',
        '36': 'Внутренняя ошибка: Некорректный addAuthID в ссылке',
        '37': 'Некорректные параметры в ссылке',
        '38': 'Внутренняя ошибка: Некорректный authID в ссылке',
        '39': 'Время жизни ссылки истекло',
        '40': 'Некорректный тип объекта',
        '41': 'Некорректный режим отображения объекта',
        '42': 'Нет доступа для просмотра объекта',
        '43': 'Вход уже выполнен под другим пользователем',
        '44': 'Вход выполнен под другим типом пользователя',
        '45': '<p>Уважаемый пользователь!</p>Вы не можете пользоваться \'Веб-интерфейсом\', так как пользователь с правами \'Главный администратор\' запретил Вам доступ к данной услуге',
        '46': 'Указанный web домен не зарегистрирован',
        '47': '<p>Уважаемый пользователь!</p><p>У Вашей компании не подключена услуга «Веб-интерфейс».</p><p>По любым вопросам, связанным с подключением и оплатой услуги «Веб-интерфейс», представитель Вашей компании может обращаться в отдел продаж компании Experium по телефону +7(495) 783-66-03 (9:00&nbsp;–&nbsp;18:00 МСК)</p>',
        '48': 'Не определены параметры входа в веб',
        '49': 'Сотрудник с указанным email не найден',
        '50': 'Больше одного сотрудника с таким email',
        '51': 'Слишком длинный пароль',
        '52': 'Слишком короткий пароль',
        '53': 'Некорректный пароль',
        '54': 'Указан такой же пароль',
        '55': '<p>Уважаемый пользователь!</p><p>У Вашей компании закончился или не был оплачен период пользования услугой \'Веб-интерфейс\'.</p><p>По любым вопросам, связанным с подключением и оплатой услуги \'Веб-интерфейс\', представитель Вашей компании может обращаться в отдел продаж компании Experium по телефону +7(495) 783-66-03 (9:00 - 18:00 МСК)</p>',
        '56': 'Пакет \'Веб-интерфейс\' недоступен, т.к. количество купленных лицензий меньше, чем количество пользователей, которым даны права на него',
        '57': 'Старый пароль не совпадает с введенным',
        '60': 'Нет прав',
        '80': 'Некорректный тип файла',
        '141': 'Заявка была аннулирована',
        '255': 'Доступ временно заблокирован. Для разблокировки введите верный логин, пароль и символы с картинки',
        'empty_document': 'Документ пустой'
    },
    errors: {
        responsibleNotBlank: 'Выберите ответственного HR-менеджера',
        companyNotBlank:     'Укажите компанию',
        positionNotBlank:    'Укажите название позиции',
        quantityNotZero:     'Количество должно быть больше нуля',
        enterQuantity:       'Укажите количество',
        enterDate:           'Введите дату',
        enterTime:           'Введите время',
        dateIsNotAfter:      'Введённая дата не должна быть позже %(date)s',
        dateIsNotBefore:     'Введённая дата не должна быть раньше %(date)s',
        required:            'Это обязательное поле для заполнения',
        passwordLength:      'Пароль должен быть не короче 6 и не длиннее 15 символов',
        passwordMustContain: 'Пароль должен содержать не менее 2 цифр и букв.',
        passwordsMustMatch:  'Пароли должны совпадать',
        lengthNotMoreThan:   'Не больше %(length)s символов',
        valueNotLessThan:    'Не меньше чем %(value)s',
        valueNotMoreThan:    'Не больше чем %(value)s',
        invalidSalaryValue:  'Некорректно (корректный пример: 2000.50)',
        mustBeLessThan:      'Значение должно быть меньше %(value)s',
        mustBeMoreThan:      'Значение должно быть больше %(value)s',
        mustBePositive:      'Значение должно быть больше 0',
        notEnoughSymbols:    'Документ не может быть сохранен, потому что не введено необходимое количество знаков! %(currentCount)s/%(min)s',
        formNotSet:          'Необходимо указать форму в конструкторе событий',
        notFound:            'Ничего не найдено',
        dateInPast:          'Дата в прошлом',
        lessThanStartTime:   'Время окончания раньше времени начала',
        incorrectDate:       'Некорректная дата',
        incorrectTime:       'Некорректное время',
        incorrectEmail:      'Некорректный email',
        wrongFiletype:       'Формат %(fileType)s не поддерживается',
        incorrectInterval:   'Некорректный интервал',
        exceededAllowedSize: 'Превышен допустимый размер файла (максимум %(size)sмб)',
        loadImageError:      'Ошибка загрузки изображения',
        emailError:          'Неверный адрес электронной почты',
        fileNotSelected:     'Файл не выбран',
        '54':                'Указан такой же пароль',
        '57':                'Старый пароль не совпадает с введенным',
        '141':               'Заявка была аннулирована',
        'incorrect':         'Некорректное значение',

        'licenseWillExpireSoon': '<div>Уважаемый пользователь!</div><div>Дата окончания оплаченного периода использования "Веб интерфейса" Experium - <b>%(date)s</b>.</div><div>Использование "Веб интерфейса" после указанной даты будет возможно только после его оплаты Вашей компанией.</div><div>По любым вопросам, связанным с оплатой и подключением "Веб интерфейса", представитель Вашей компании может обращаться в отдел продаж Experium по телефону +7(495) 783-66-03.</div>',
        warning: 'Предупреждение',
        couldNotOpenWindow: 'Не удалось открыть окно',
        couldNotOpenSidebar: 'Не удалось открыть сайдбар',
        couldNotOpenPage: 'Не удалось открыть страницу',
        toStartPage: 'На начальную страницу',
        matchDefault: 'Поля не совпадают',
        rangeDefault: 'Неверная длина поля',
        saveError: 'Ошибка сохранения',
        saveDocumentError: 'Не удалось прикрепить документ',

        dateNotAllowed: {
            one: 'Дату события можно перенести только на один день',
            few: 'Дату события можно перенести только на %(count)s дня',
            many: 'Дату события можно перенести только на %(count)s дней'
        },
        subscribeError: 'Не удалось подписаться на уведомления',
        notExistEvent: 'Данное событие не существует',
        dateIsNowOrBefore: 'Дата не должна превышать текущую',

        appError: 'Ошибка в работе приложения',
        'sso': 'Не удалось авторизоваться через домен',
        maxTextFieldLength: 'Максимальное количество знаков %(value)s'
    }
};
